"use client";

import { c as _c } from "react/compiler-runtime";
import { useParams } from "next/navigation";
import { useEffect } from "react";
import { useTestimonyDelete } from "@/app/(main)/(club)/mes-clubs/[id]/hooks/use-testimony-delete";
import { useModalStore } from "@/stores/modal-store";
import { TestimonyRead } from "@/TS/Interfaces/global_interfaces";
import { CtaTestimony } from "./cta-testimony";
interface DeleteTestimonyProps {
  testimony: TestimonyRead;
  closeModal: () => void;
}
export const DeleteTestimony: React.FC<DeleteTestimonyProps> = t0 => {
  const $ = _c(28);
  const {
    testimony,
    closeModal
  } = t0;
  const {
    close
  } = useModalStore();
  const params = useParams();
  const {
    mutate: deleteTestimony,
    isPending,
    error: deleteTestimonyError,
    isSuccess: deleteTestimonySuccess
  } = useTestimonyDelete(testimony.id, params.id as string);
  let t1;
  if ($[0] !== deleteTestimony || $[1] !== testimony.id) {
    t1 = () => {
      deleteTestimony(testimony.id);
    };
    $[0] = deleteTestimony;
    $[1] = testimony.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleDelete = t1;
  let t2;
  let t3;
  if ($[3] !== close || $[4] !== deleteTestimonySuccess) {
    t2 = () => {
      if (deleteTestimonySuccess) {
        const timer = setTimeout(() => {
          close();
        }, 3000);
        return () => clearTimeout(timer);
      }
    };
    t3 = [deleteTestimonySuccess, close];
    $[3] = close;
    $[4] = deleteTestimonySuccess;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="text-xl font-bold mb-6 text-center">Supprimer un témoignage</h2>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <br />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== testimony.witness.firstName || $[10] !== testimony.witness.lastName) {
    t6 = <p className="text-center">Vous êtes sur le point de supprimer le témoignage de{" "}{testimony.witness.firstName} {testimony.witness.lastName}.{t5}Êtes-vous sûr de vouloir supprimer ce témoignage ?</p>;
    $[9] = testimony.witness.firstName;
    $[10] = testimony.witness.lastName;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      border: "border-0"
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = deleteTestimonySuccess ? "Fermer" : "Annuler";
  let t9;
  if ($[13] !== closeModal || $[14] !== deleteTestimonySuccess || $[15] !== handleDelete || $[16] !== isPending || $[17] !== t8) {
    t9 = <CtaTestimony style={t7} isPending={isPending} handleDelete={handleDelete} closeModal={closeModal} success={deleteTestimonySuccess} cancelLabel={t8} />;
    $[13] = closeModal;
    $[14] = deleteTestimonySuccess;
    $[15] = handleDelete;
    $[16] = isPending;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== deleteTestimonySuccess) {
    t10 = deleteTestimonySuccess && <div className="flex flex-col gap-4"><div className="text-center text-success2 font-medium py-2 bg-success rounded-lg animate-fadeIn">Témoignage supprimé avec succès</div></div>;
    $[19] = deleteTestimonySuccess;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== deleteTestimonyError) {
    t11 = deleteTestimonyError && <div className="flex flex-col gap-4"><div className="text-center text-white font-medium py-2 bg-primary rounded-lg animate-fadeIn">Erreur lors de la suppression du témoignage</div></div>;
    $[21] = deleteTestimonyError;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t6 || $[26] !== t9) {
    t12 = <div className="flex flex-col gap-4 justify-between h-full mt-5">{t4}{t6}{t9}{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t6;
    $[26] = t9;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};